import { optionTitle_weather } from './WeatherOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let WeatherOption: LazyOption = createLazyOption(
    {
        key: 'weatherOption',
        titleStringKey: optionTitle_weather,
        searchTermsStringKey: optionTitle_weather,
        allowedOptionKeys: ['Weather'],
    },
    lazyFullModule,
    m => m.default
);
export default WeatherOption;
